/* tinyyytales landing page — interactions.
   State tables are the artboard's own; this only replaces the renderer. */
(function () {
  var D = window.__ttlp; if (!D) return;
  var root = document.querySelector('[data-ttlp]'); if (!root) return;
  var S = Object.assign({}, D.defaults);
  var q = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var slot = function (i) { return root.querySelector('[data-tt-i="' + i + '"]'); };

  function setSlots(key, val) {
    (D.slots[key] || []).forEach(function (i) { var e = slot(i); if (e) e.textContent = val; });
  }
  function group(name) {
    var r = D.press[name]; if (!r) return [];
    return q('[data-tt-p]').filter(function (e) {
      var i = +e.getAttribute('data-tt-p'); return i >= r[0] && i < r[1];
    });
  }
  function press(name, idx) {
    group(name).forEach(function (e, i) { e.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
  }
  function style(el, o) { for (var k in o) el.style[k] = o[k]; }

  function render() {
    setSlots('color', D.colors[S.color]);
    setSlots('size', D.sizes[S.size]);
    setSlots('cm', D.cms[S.size]);
    setSlots('cta', D.cta[S.bundle]);
    setSlots('sticky', D.sticky[S.bundle]);
    // gift copy is owned by the rail in extra.js now

    press('color', S.color); press('size', S.size);
    press('bundle', S.bundle); press('filter', S.filter);

    group('color').forEach(function (e, i) {
      e.style.boxShadow = i === S.color ? D.style.swatchOn : D.style.swatchOff; });
    group('size').forEach(function (e, i) {
      style(e, i === S.size ? D.style.sizeOn : D.style.sizeOff); });
    group('bundle').forEach(function (e, i) {
      style(e, i === S.bundle ? D.style.packOn : D.style.packOff); });
    group('filter').forEach(function (e, i) {
      style(e, i === S.filter ? D.style.filterOn : D.style.filterOff); });


    var big = root.querySelector('[data-tt-big]');
    var th = q('[data-tt-thumb]')[S.img];
    var src = (th && th.getAttribute('data-tt-src')) || D.slides[S.img];
    if (big && src) big.src = src;
    q('[data-tt-ov]').forEach(function (e) { e.style.display = S.img === 0 ? '' : 'none'; });
    q('[data-tt-thumb]').forEach(function (e, i) {
      e.style.boxShadow = i === S.img ? '0 0 0 2px #1E2B1B' : 'none'; });

    q('[data-tt-e]').forEach(function (e, i) {
      var open = i === S.faq;
      e.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = e.nextElementSibling;
      if (panel) panel.style.display = open ? '' : 'none';
      var ic = e.querySelector('svg, [data-tt-rot]');
      if (ic) ic.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
    });
  }

  function bind(name, key) {
    group(name).forEach(function (e, i) {
      e.addEventListener('click', function (ev) {
        if (ev.target.closest && ev.target.closest('.ttlp-pickers')) return;
        ev.preventDefault(); S[key] = i; render(); });
    });
  }
  bind('color', 'color'); bind('size', 'size');
  bind('bundle', 'bundle'); bind('filter', 'filter');
  q('[data-tt-thumb]').forEach(function (e, i) {
    e.addEventListener('click', function (ev) { ev.preventDefault(); S.img = i; render(); }); });
  q('[data-tt-e]').forEach(function (e, i) {
    e.addEventListener('click', function (ev) {
      ev.preventDefault(); S.faq = (S.faq === i ? -1 : i); render(); }); });

  render();
})();

/* changes requested on top of the ported artboard:
   per-pair pickers, colour-driven imagery, gift lock states */
(function () {
  var D = window.__ttlp; if (!D) return;
  var root = document.querySelector('[data-ttlp]'); if (!root) return;
  var q = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };

  var PACK_OF_INDEX = { 0: 11, 1: 12, 2: 13 };

  function showPickers(bundleIdx) {
    var want = PACK_OF_INDEX[bundleIdx];
    q('[data-ttlp-pickers]').forEach(function (el) {
      el.hidden = +el.getAttribute('data-ttlp-pickers') !== want;
    });
  }

  function setHero(colourIdx) {
    var src = (D.colourImages || [])[colourIdx];
    if (!src) return;
    var big = root.querySelector('[data-tt-big]');
    if (big) { big.src = src; big.setAttribute('data-tt-colourlocked', '1'); }
  }

  function setRowThumbs(sel) {
    var thumb = (D.colourThumbs || [])[+sel.value];
    var row = sel.closest('.ttlp-row');
    if (row && thumb) { var im = row.querySelector('[data-ttlp-thumb]'); if (im) im.src = thumb; }
  }

  // the gift rail mirrors the competitor: four tiles, each with its own
  // unlock threshold, and the wash-bag tile restates itself at 9 pairs
  var GIFTS = [
    { unlock: 0, label: ['Free Wash Bags', 'Free Wash Bags', 'Free Wash Bags'],
      value: ['$14.99', '$14.99', '$29.99'] },
    { unlock: 0, label: 'Premium Shoe Insoles Upgrade (All Pairs)', value: '$29.99' },
    { unlock: 1, label: 'Free Shipping', value: '$7.99' },
    { unlock: 2, label: '4 Pairs of Premium Non-Slip Socks', value: '$39.99' }
  ];
  var BAR = ['33.3%', '66.6%', '100%'];

  function pick(v, i) { return Object.prototype.toString.call(v) === '[object Array]' ? v[i] : v; }

  function lockState(bundleIdx) {
    GIFTS.forEach(function (g, i) {
      var open = bundleIdx >= g.unlock;
      var tile = root.querySelector('[data-ttg="' + i + '"]');
      var lock = root.querySelector('[data-ttg-lock="' + i + '"]');
      var val  = root.querySelector('[data-ttg-val="' + i + '"]');
      var lab  = root.querySelector('[data-ttg-label="' + i + '"]');
      if (lock) lock.hidden = open;
      if (tile) tile.className = 'ttg' + (open ? '' : ' is-locked');
      if (val)  val.innerHTML = 'FREE <s>' + pick(g.value, bundleIdx) + '</s>';
      if (lab)  lab.textContent = pick(g.label, bundleIdx);
    });
    var bar = root.querySelector('[data-tt-bar]');
    if (bar) bar.style.width = BAR[bundleIdx];
  }

  // every pair's colour select drives its own thumbnail; pair 1 drives the hero
  q('[data-ttlp-colour]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      setRowThumbs(sel);
      var rows = q('.ttlp-row', sel.closest('.ttlp-pickers'));
      if (rows.length && rows[0].contains(sel)) setHero(+sel.value);
    });
  });

  // the standalone swatches are gone; this only runs if they are ever restored
  [0,1,2,3,4].map(function (i) { return root.querySelector('[data-tt-p="'+i+'"]'); })
    .forEach(function (btn, i) { if (!btn) return;
    btn.addEventListener('click', function () {
      setHero(i);
      q('[data-ttlp-colour]').forEach(function (s) { s.value = String(i); setRowThumbs(s); });
    });
  });

  // pack choice shows that card's pickers and updates the padlocks
  [11,12,13].map(function (n) { return root.querySelector('[data-tt-p="'+n+'"]'); })
    .forEach(function (btn, i) { if (!btn) return;
      btn.addEventListener('click', function () { showPickers(i); lockState(i); });
    });

  showPickers(D.defaults.bundle);
  lockState(D.defaults.bundle);
  // the gallery opens on the product's first image; a colour photo only replaces it once a colour is picked
})();
